import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
const spin = keyframes `
  to { transform: rotate(360deg); }
`;
const sizeMap = {
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
};
export const Spinner = styled.div `
  width: ${({ size = 'md' }) => sizeMap[size]};
  height: ${({ size = 'md' }) => sizeMap[size]};
  border: 2px solid ${({ theme }) => theme.colors.border.default};
  border-top-color: ${({ theme, color }) => color || theme.colors.brand.primary};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`;
//# sourceMappingURL=Spinner.js.map